import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import CreatedWithUrlToast from '@/components/toasts/CreatedWithUrlToast';

const CohortCreatedToast = ({ name, code }) => (
  <CreatedWithUrlToast
    className="aridhia-cohort-created-toast"
    messageId="toast.your.cohort"
    name={name}
    url={codeUrl(urls.COHORTS, code)}
  />
);

export default CohortCreatedToast;
